/**
 * Dependencies.
 */
import {
  getModule,
  Module,
  Mutation,
  VuexModule
} from 'vuex-module-decorators';

import { ServicePointOrderModel } from '@/api/service-point/order/order.model';
import store from '@/plugins/store.plugin';

/**
 * Store.
 */
@Module({
  dynamic: true,
  name: 'servicePoint',
  namespaced: true,
  store
})
export default class ServicePoint extends VuexModule {
  /**
   * Property `orders`.
   */
  orders: ServicePointOrderModel[] = null;

  /**
   * Property `order`.
   */
  order: ServicePointOrderModel = null;

  /**
   * Property `deliverTrackingNumberKey`.
   */
  deliverTrackingNumberKey: string = null;

  /**
   * Mutation `setOrders`.
   */
  @Mutation
  setOrders(orders: ServicePointOrderModel[]) {
    this.orders = [...orders];
  }

  /**
   * Mutation `setOrderPackages`.
   */
  @Mutation
  setOrder(order: ServicePointOrderModel) {
    this.order = order;
  }

  /**
   * Mutation `setDeliverTrackingNumberKey`.
   */
  @Mutation
  setDeliverTrackingNumberKey(key: string) {
    this.deliverTrackingNumberKey = key;
  }
}

/**
 * Export `servicePointStore`.
 */
export const servicePointStore = getModule(ServicePoint);
